var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceFileDownload = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 58,
  height: 58,
  viewBox: "0 0 58 58",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#h8kshcjm8a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44 9H14a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4z",
  fill: "#000"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44 9H14a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4z",
  fill: "#46CC88"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.954 17v14.598l-5.59-5.252-1.277 1.365 7.802 7.328 7.802-7.328-1.278-1.364-5.59 5.25V17h-1.869zM19 35.971h20.087v1.869H19V35.97z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "h8kshcjm8a",
  x: 0,
  y: 0,
  width: 58,
  height: 58,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.054902 0 0 0 0 0.203922 0 0 0 0 0.454902 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_255_4536"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_255_4536",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceFileDownload);
export default ForwardRef;